module.exports = __webpack_public_path__ + "static/media/AboutPage__Carolyn.642439f4.jpg";